import React from "react";
import { MainContainer } from './styles';

export default props => {
    return (
        <MainContainer>
            {props.data.children.map((child, key) => (
                <label key={key} >
                    <input type="checkbox" value={child.title} checked={child.checked} id={child.key} onChange={props.onChange} />
                    <span>{child.title}</span>
                </label>
            ))}
        </MainContainer>
    );
};